import DeMinimis from "./DeMinimis";
import GberArt20 from "./GberArt20";
import GberArt20A from "./GberArt20A";
import React, { Component } from 'react';

class StateAidLetter extends Component {

    getProjectStateAid = (partner) => {
        // console.log(partner.detail.stateAid?.stateAidScheme?.measure);
        switch (partner.detail.stateAid?.stateAidScheme?.measure) {
            case 'GBER_ARTICLE_20A':
                return <GberArt20A />;
            case 'GBER_ARTICLE_20':
                return <GberArt20 />;
            case 'DE_MINIMIS':
                return <DeMinimis />;
            default:
                return undefined;
        }
    }

    generateAllLetters = () => {
        const project = this.props.projectState.project;
        const partners = this.props.projectState.partners;
        return (
            <div>
                {partners.map((partner, index) => (
                    <div key={index}>
                        {this.getProjectStateAid(partner)}
                    </div>
                ))}
            </div>
        )
    }

    render() {
        return (
            <div>
                {this.generateAllLetters()}
            </div>
        )
    }
}

export default StateAidLetter;